<script setup lang="ts">
import { getClasses } from '~/js/composables/classes'

interface Props {
    utilities?: string,
    theme?: string|null,
}

withDefaults(defineProps<Props>(), {
    utilities: '',
    theme: null,
})

const classes = {
    wrapper: {
        _default: 'place-self-start relative overflow-hidden pointer-events-none',
        animation: 'transition-colors',
        color: 'bg-white',
        border: 'border border-neutral-100',
        flex: 'flex flex-col',
        size: 'w-full',
        shadow: 'shadow-md',
    },
    flair: {
        animate: 'animate-flair',
        color: 'bg-gradient-to-r from-transparent via-white/40 to-transparent',
        position: 'absolute top-0 left-0',
        size: 'w-full h-full',
    },
    image: {
        size: 'w-full',
        color: 'bg-neutral-200/40',
        ratio: 'aspect-[3/2] md:aspect-video',
    },
    content: {
        spacing: 'p-6 pb-2 space-y-2',
    },
    block: {
        spacing: 'h-5',
        color: 'bg-neutral-200/40',
    },
    badges: {
        flex: 'flex items-center gap-2',
        spacing: 'p-6 pt-2',
    },
    badge: {
        spacing: 'h-7 w-20',
        color: 'bg-neutral-200/40',
    },
}
</script>

<template>
    <article
        :class="[
            getClasses(classes,'wrapper'),
            utilities
        ]"
        :data-theme="theme"
    >
        <div :class="getClasses(classes, 'flair')"></div>

        <div :class="getClasses(classes, 'image')" />

        <div :class="getClasses(classes, 'content')">
            <div :class="[
                getClasses(classes, 'block')
            ]" />
            <div :class="[
                getClasses(classes, 'block')
            ]" />
        </div>

        <div :class="getClasses(classes, 'content')">
            <div :class="[
                getClasses(classes, 'block'),
                'w-3/4'
            ]" />
            <div :class="[
                getClasses(classes, 'block'),
                'w-2/3'
            ]" />
        </div>

        <div :class="getClasses(classes, 'badges')">
            <div :class="getClasses(classes, 'badge')" />
            <div :class="[
                getClasses(classes, 'badge'),
                'w-2/3'
            ]" />
        </div>

        <div :class="getClasses(classes, 'content')">
            <div :class="[
                getClasses(classes, 'block'),
                'w-22 mb-4'
            ]" />
        </div>
    </article>
</template>